module.exports = __webpack_public_path__ + "static/konstancin-1e8e53369e0a14a97a7e45e33a8ca670.png";